export default "__VITE_ASSET__Bb2uoI0g__"